export default "__VITE_ASSET__CLm1r5QF__"